// Apply-brief for suggestions. Detection is deterministic and CAI never edits the
// target files itself — applying is delegated to an external agent via this brief.
//
// Note: the design referenced reusing the sync brief (buildCombinedBrief), but that
// brief is shaped around DriftIssues ("fix these drift issues"). Surfacing a
// suggestion through it would mislabel it. A suggestion-specific brief keeps the
// intent (delegate, no CAI-side edits) while reading honestly.

import { readFileSync } from "node:fs";
import { resolve } from "node:path";
import type { Suggestion } from "../types.js";

/** Build a delegate-able brief for one suggestion. Reads involved files for context. */
export function buildSuggestionBrief(suggestion: Suggestion, projectRoot: string): string {
  const fileSections = suggestion.files.map((file) => {
    let content: string;
    try {
      content = readFileSync(resolve(projectRoot, file), "utf-8");
    } catch {
      content = "(file could not be read)";
    }
    return `**${file}:**\n\`\`\`\n${content}\n\`\`\``;
  });

  return `A scaffold improvement opportunity was detected. Apply it if it makes sense; \
otherwise explain why not. Make only the change described — do not rewrite unrelated content.

**Suggestion (${suggestion.kind}):** ${suggestion.title}

**Why:** ${suggestion.rationale}

**Estimated saving:** ~${suggestion.estimatedSaving} tokens (rough ranking estimate)
${fileSections.length ? `\n**Files involved:**\n\n${fileSections.join("\n\n")}` : ""}`;
}
